export default function DeleteIconRed({
  pathClassName,
}: {
  pathClassName?: string;
}) {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={pathClassName}
          d="M14.25 6.75L13.7131 13.7301C13.5928 15.2931 12.2895 16.5 10.7219 16.5H7.27809C5.71048 16.5 4.40716 15.2931 4.28693 13.7301L3.75 6.75M15.75 5.25C13.8016 4.30048 11.4852 3.75 9 3.75C6.51476 3.75 4.19844 4.30048 2.25 5.25M7.5 3.75V3C7.5 2.17157 8.17157 1.5 9 1.5C9.82843 1.5 10.5 2.17157 10.5 3V3.75M7.5 8.25V12.75M10.5 8.25V12.75"
          stroke="#FF3838"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
    </>
  );
}
